module.exports = __webpack_public_path__ + "assets/img/img_tdzx_bj.a621597e.png";